import React from 'react'

export const StopSquareIcon = ({ className }: { className?: string }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className || ''}
  >
    <title>StopSquareIcon</title>
    <path
      d="M2.5 6.5C2.5 5.09987 2.5 4.3998 2.77248 3.86502C3.01217 3.39462 3.39462 3.01217 3.86502 2.77248C4.3998 2.5 5.09987 2.5 6.5 2.5H13.5C14.9001 2.5 15.6002 2.5 16.135 2.77248C16.6054 3.01217 16.9878 3.39462 17.2275 3.86502C17.5 4.3998 17.5 5.09987 17.5 6.5V13.5C17.5 14.9001 17.5 15.6002 17.2275 16.135C16.9878 16.6054 16.6054 16.9878 16.135 17.2275C15.6002 17.5 14.9001 17.5 13.5 17.5H6.5C5.09987 17.5 4.3998 17.5 3.86502 17.2275C3.39462 16.9878 3.01217 16.6054 2.77248 16.135C2.5 15.6002 2.5 14.9001 2.5 13.5V6.5Z"
      stroke="#4A4C50"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66667 8C6.66667 7.53329 6.66667 7.29993 6.75749 7.12167C6.83739 6.96487 6.96487 6.83739 7.12167 6.75749C7.29993 6.66667 7.53329 6.66667 8 6.66667H12C12.4667 6.66667 12.7001 6.66667 12.8783 6.75749C13.0351 6.83739 13.1626 6.96487 13.2425 7.12167C13.3333 7.29993 13.3333 7.53329 13.3333 8V12C13.3333 12.4667 13.3333 12.7001 13.2425 12.8783C13.1626 13.0351 13.0351 13.1626 12.8783 13.2425C12.7001 13.3333 12.4667 13.3333 12 13.3333H8C7.53329 13.3333 7.29993 13.3333 7.12167 13.2425C6.96487 13.1626 6.83739 13.0351 6.75749 12.8783C6.66667 12.7001 6.66667 12.4667 6.66667 12V8Z"
      stroke="#4A4C50"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
